/**
 * Site Configuration for trans-treffen.de
 * Minimal config - only URL and affiliate link
 * All text content is in locale files
 */

export const siteConfig = {
  // Base URL
  baseUrl: 'https://trans-treffen.de',
  
  // City slug prefix (German: "trans-treffen-" = "meet trans")
  citySlugPrefix: 'trans-treffen-',
  
  // Affiliate/Monetization
  affiliate: {
    link: 'https://t.crjmpy.com/345641/6497?bo=2753,2754,2755,2756&aff_sub5=SF_006OG000004lmDN'
  },
  
  // Article Generation Configuration
  articleGeneration: {
    // Language for generated articles ('de' for German, 'en' for English)
    language: 'de',
    
    // Theme/topic for articles
    theme: 'dating trans women',
    
    // Page types to generate (slugs are in locale files)
    pageTypes: {
      // Global hub page (slug from locale: pages.slugs.globalHub)
      globalHub: {
        enabled: true,
        localeKey: 'pages.slugs.globalHub',
        priority: 1.0
      },
      // Segment pages (slugs from locale: pages.slugs.*)
      segmentPages: {
        enabled: true,
        pages: [
          { localeKey: 'pages.slugs.apps', type: 'apps', priority: 0.9 },
          { localeKey: 'pages.slugs.bestSites', type: 'comparison', priority: 0.9 },
          { localeKey: 'pages.slugs.hookups', type: 'hookups', priority: 0.9 },
          { localeKey: 'pages.slugs.sexDating', type: 'adult', priority: 0.9 },
          { localeKey: 'pages.slugs.howToDate', type: 'advice', priority: 0.8 },
          { localeKey: 'pages.slugs.tips', type: 'tips', priority: 0.8 },
          { localeKey: 'pages.slugs.topApps', type: 'ranking', priority: 0.9 }
        ]
      },
      // City pages (lightweight, 50-100 words)
      cityPages: {
        enabled: true,
        wordCount: 100,
        priority: 0.7
      }
    },
    
    // Output directory for generated articles
    outputDir: 'src/data/articles'
  }
}

/**
 * Get cloaked affiliate link (clean URL that redirects to affiliate)
 * @returns {string} Cloaked affiliate link URL
 */
export const getAffiliateLink = () => {
  return `${siteConfig.baseUrl}/anmelden`
}

/**
 * Get direct affiliate link (for redirects)
 * @returns {string} Direct affiliate link URL
 */
export const getDirectAffiliateLink = () => {
  return siteConfig.affiliate.link
}

/**
 * Get city slug with prefix for URLs
 * @param {string} baseSlug - The base city slug (e.g., "berlin")
 * @returns {string} Full slug with prefix (e.g., "trans-treffen-berlin")
 */
export const getCitySlugWithPrefix = (baseSlug) => {
  return `${siteConfig.citySlugPrefix}${baseSlug}`
}

/**
 * Extract base city slug from URL slug (removes prefix)
 * @param {string} urlSlug - The slug from URL (e.g., "trans-treffen-berlin")
 * @returns {string} Base slug (e.g., "berlin")
 */
export const getBaseSlugFromUrl = (urlSlug) => {
  if (!urlSlug) return null
  if (urlSlug.startsWith(siteConfig.citySlugPrefix)) {
    return urlSlug.substring(siteConfig.citySlugPrefix.length)
  }
  // Fallback: if no prefix, assume it's already a base slug (for backwards compatibility)
  return urlSlug
}

/**
 * Generate sitemap URL for a city
 * @param {string} citySlug - The base city slug (e.g., "berlin")
 * @returns {string} Full URL with prefix
 */
export const getCityUrl = (citySlug) => {
  const fullSlug = getCitySlugWithPrefix(citySlug)
  return `${siteConfig.baseUrl}/${fullSlug}`
}

/**
 * Generate sitemap entry for a city
 * @param {Object} city - City object with Slug property
 * @returns {Object} Sitemap entry
 */
export const generateCitySitemapEntry = (city) => {
  const lastmod = new Date().toISOString().split('T')[0]
  return {
    loc: getCityUrl(city.Slug),
    lastmod,
    changefreq: 'weekly',
    priority: 0.8
  }
}

/**
 * Generate full sitemap XML
 * @param {Array} cities - Array of city objects
 * @returns {string} Sitemap XML string
 */
export const generateSitemap = (cities) => {
  const lastmod = new Date().toISOString().split('T')[0]
  const entries = [
    {
      loc: siteConfig.baseUrl,
      lastmod,
      changefreq: 'weekly',
      priority: 1.0
    },
    ...cities.map(generateCitySitemapEntry)
  ]
  
  const urlEntries = entries.map(entry => `  <url>
    <loc>${entry.loc}</loc>
    <lastmod>${entry.lastmod}</lastmod>
    <changefreq>${entry.changefreq}</changefreq>
    <priority>${entry.priority}</priority>
  </url>`).join('\n')
  
  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urlEntries}
</urlset>`
}

